import { render, staticRenderFns } from "./DailyActivityTable.vue?vue&type=template&id=2bb962d4&"
import script from "./DailyActivityTable.vue?vue&type=script&lang=js&"
export * from "./DailyActivityTable.vue?vue&type=script&lang=js&"
import style0 from "./DailyActivityTable.vue?vue&type=style&index=0&id=2bb962d4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports